module.exports = __webpack_public_path__ + "static/media/logo.f83af60c.png";